import { WorkflowLocation } from '../../helpers/matchers'

export const taskActions = {
  CreateIntegrationTask: 'createIntegrationTask',
  Delete: 'delete',
  ViewInProvider: 'viewInProvider',
}

export const shouldRenderContextMenu = (phaseIsComplete, workflowLocation) =>
  !phaseIsComplete && workflowLocation !== WorkflowLocation.Popover
